import React, { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { KeyRound, ShieldCheck } from "lucide-react";

export default function ForcePasswordChange() {
  const { setUser } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("New passwords don't match.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      const { data } = await api.get("/auth/me");
      setUser(data);
      toast.success("Password updated — welcome aboard!");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16" data-testid="force-password-change">
      <div className="w-full max-w-md card-soft">
        <div className="flex items-center gap-2 mb-1 text-[#2D6A4F]">
          <ShieldCheck className="w-5 h-5" />
          <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#CC5A3A]">Secure your account</span>
        </div>
        <h1 className="font-heading text-2xl text-[#1E3F33] mb-2">Set your own password</h1>
        <p className="text-sm text-[#5C6B64] mb-5">You're signing in with a temporary password set by the main admin. Please choose a new password to continue.</p>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-[#5C6B64]">Temporary password</label>
            <input data-testid="force-current-password" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="input-soft mt-1" autoComplete="current-password" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-[#5C6B64]">New password</label>
            <input data-testid="force-new-password" type="password" value={next} onChange={(e) => setNext(e.target.value)} className="input-soft mt-1" placeholder="Min 8 chars, mixed case + number" autoComplete="new-password" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-[#5C6B64]">Confirm new password</label>
            <input data-testid="force-confirm-password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input-soft mt-1" autoComplete="new-password" />
          </div>
          <button type="submit" disabled={saving || !current || !next || !confirm} data-testid="force-password-submit" className="btn-primary w-full inline-flex items-center justify-center gap-2 disabled:opacity-50">
            <KeyRound className="w-4 h-4" /> {saving ? "Saving…" : "Set password & continue"}
          </button>
        </form>
      </div>
    </div>
  );
}
